import NegativeTrendIcon from "@shared/icons/NegativeTrendIcon";
import PositiveTrendIcon from "@shared/icons/PositiveTrendIcon";
import StudentCircleYellowIcon from "@shared/icons/StudentCircleYellowIcon";
import { Skeleton } from "@material-ui/lab";
import React from "react";
import CheckStatIcon from "@shared/icons/CheckStatIcon";
import XStatIcon from "@shared/icons/navigation/XStatIcon";

const StatBox = ({
  type,
  data,
  title,
  subtext = "",
  loading = false,
  trend = "",
}) => {
  let icon;

  if (type === "totalStudent" || type === "totalEnrollment") {
    icon = <StudentCircleYellowIcon />;
  } else if (trend === "pass") {
    icon = <CheckStatIcon className="" />;
  } else if (trend === "fail") {
    icon = <XStatIcon className="" />;
  } else if (data?.percentChange < 0 || trend === "negative") {
    icon = <NegativeTrendIcon />;
  } else if (data?.percentChange >= 0 || trend === "positive") {
    icon = <PositiveTrendIcon />;
  }

  const showComparison =
    type !== "totalEnrollment" && !!data?.percentChange && !!data?.dateRange;

  return (
    <div
      className="p-16 md:p-20 border rounded-md border-gray-300 flex-1 "
      style={{ maxWidth: "41rem" }}
    >
      <div className="flex items-center gap-16 md:gap-28">
        {loading ? (
          <Skeleton
            className="rounded-full"
            height={57}
            variant="rect"
            width={56}
          />
        ) : (
          <div>{icon}</div>
        )}
        <div className="flex gap-2 flex-col">
          {loading ? (
            <Skeleton
              className="mb-12"
              height={28}
              variant="rect"
              width={100}
            />
          ) : (
            <p
              className="font-bold text-gray-9000"
              style={{
                fontSize: "clamp(1.6rem, 2vw, 3rem)",
              }}
            >
              {data.total}
            </p>
          )}
          {loading ? (
            <Skeleton className="mb-4" height={12} variant="rect" width={100} />
          ) : (
            <>
              <p className="text-12 lg:text-16 font-bold ">{title}</p>
              {subtext ? (
                <span
                  className={`${subtext.includes("-") ? "text-red-500" : "text-green-500"} text-12 lg:text-16`}
                >
                  {subtext}
                </span>
              ) : null}
            </>
          )}

          {loading ? (
            <Skeleton height={12} variant="rect" width={100} />
          ) : showComparison ? (
            <p
              className={`text-12 font-medium ${
                data.percentChange >= 0 ? "text-green-500" : "text-red-500"
              }`}
            >
              (
              {data.percentChange >= 0
                ? `+${data.percentChange}`
                : data.percentChange}
              %){" "}
            </p>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default StatBox;
